<ng-container *ngIf="isLoginPage(); else layout">
  <router-outlet></router-outlet>
</ng-container>
<ng-template #layout>
  <cc-erp-layout
    *ngIf="showLayout"
    [themes]="themes"
    [showEditMenuBtn]="showEditMenu"
    (onEditMenu)="saveMenu($event)"
    [hideNav]="true"
    [environment]="environment"
    (onDarkModeToggle)="handleDarkMode($event)"
  >
    <router-outlet></router-outlet>
  </cc-erp-layout>
</ng-template>
